import styled from 'styled-components';
import { PH, poshubTableStyles } from './theme';

/**
 * Ant Design Drawer renders content in a portal (e.g. document.body), so it is NOT
 * under StyledMenusTab in the DOM. Drawer-only styles must live on a wrapper
 * inside the Drawer so styled-components selectors match.
 */
export const StyledMenuDrawerBody = styled.div`
  ${poshubTableStyles}

  .poshub-drawer-meta-row {
    padding-bottom: 14px;
    margin-bottom: 16px;
    border-bottom: 1px solid ${PH.border};
    font-size: ${PH.fontSizeSm};
    color: ${PH.textMuted};
  }

  .poshub-collapse.ant-collapse {
    background: transparent;
    border: none;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .ant-collapse-item {
      border: 1px solid ${PH.border};
      border-radius: 4px !important;
      overflow: hidden;
    }

    .ant-collapse-header {
      font-size: ${PH.fontSizeBase};
      font-weight: 700;
      color: ${PH.text};
      padding: 11px 16px !important;
      background: #f8f9fb;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center !important;
    }

    .ant-collapse-expand-icon {
      margin-inline-end: 0 !important;
      margin-inline-start: 16px !important;
    }

    .ant-collapse-content {
      border-top: 1px solid ${PH.border};
    }

    .ant-collapse-content-box {
      padding: 12px 16px 14px !important;
    }

    .poshub-console-table.ant-table-wrapper .ant-table-container {
      border: none;
      border-radius: 0;
    }
  }

  .poshub-menus-empty {
    font-size: ${PH.fontSizeBase};
    color: ${PH.textMuted};
    padding: 16px;
    border: 1px dashed ${PH.border};
    border-radius: 4px;
  }

  .poshub-menu-items-section-title {
    margin-top: 28px;
    padding-top: 22px;
    border-top: 2px solid ${PH.border};
    margin-bottom: 16px;
    font-size: ${PH.fontSizeSection};
    font-weight: 700;
    color: ${PH.text};
    line-height: 24px;
  }
`;

export const StyledMenusTab = styled.div`
  font-size: ${PH.fontSizeBase};
  line-height: ${PH.lineHeightBody};
  color: ${PH.text};

  ${poshubTableStyles}

  .menus-header {
    margin-bottom: 16px;
    display: flex;
    justify-content: flex-end;
  }

  .poshub-modal-catalog-sidebar {
    border-right: 1px solid ${PH.border};
  }

  .poshub-modal-section-title {
    font-size: ${PH.fontSizeLg};
    font-weight: 600;
    color: ${PH.text};
  }
`;
